import React from "react";
import PropTypes from "prop-types";
import userProfiler from "modules/userprofiler";
import _ from "../../utils/translation";
import GraphQLProductCard from "../product-card/graphql-product-card";
import LystSlider from "../lyst-slider/lyst-slider";
import style from "./recently-viewed.css";

function RecentlyViewed({ products, country }) {
    // TODO Add isLoggedin to apollo global state
    const productCards = products.map((productData, index) => (
        <GraphQLProductCard
            key={index}
            {...productData}
            country={country}
            isLoggedIn={userProfiler.isLoggedIn()}
        />
    ));

    return (
        <div className={style.block}>
            <div className={style.title}>
                <h4>{_("product.recently_viewed.title")}</h4>
            </div>
            <LystSlider>{productCards}</LystSlider>
        </div>
    );
}

RecentlyViewed.defaultProps = {
    products: []
};

RecentlyViewed.propTypes = {
    products: PropTypes.array,
    country: PropTypes.string
};

export default RecentlyViewed;
